import { portalApi } from '../../../api';

const CREATE_PASSWORD_VALIDATE_USER = 'CREATE_PASSWORD_VALIDATE_USER';
const CREATE_PASSWORD_VALIDATE_USER_SUCCESS = 'CREATE_PASSWORD_VALIDATE_USER_SUCCESS';
const CREATE_PASSWORD_VALIDATE_USER_FAILURE = 'CREATE_PASSWORD_VALIDATE_USER_FAILURE';

export const validateUserToCreatePassword = (userEmail, passwordKey) => async dispatch => {
  dispatch({ type: CREATE_PASSWORD_VALIDATE_USER });

  try {
    const response = await portalApi.validateUserCreatePassword(userEmail, passwordKey);
    dispatch({ type: CREATE_PASSWORD_VALIDATE_USER_SUCCESS, response });
  } catch (error) {
    dispatch({ type: CREATE_PASSWORD_VALIDATE_USER_FAILURE, error });
  }
};

const CREATE_PASSWORD_CREATE_PASSWORD = 'CREATE_PASSWORD_CREATE_PASSWORD';
const CREATE_PASSWORD_CREATE_PASSWORD_SUCCESS = 'CREATE_PASSWORD_CREATE_PASSWORD_SUCCESS';
const CREATE_PASSWORD_CREATE_PASSWORD_FAILURE = 'CREATE_PASSWORD_CREATE_PASSWORD_FAILURE';

export const createUserPassword = (userId, userPassword, passwordKey) => async dispatch => {
  dispatch({ type: CREATE_PASSWORD_CREATE_PASSWORD });

  try {
    const response = await portalApi.createUserPassword(userId, userPassword, passwordKey);
    dispatch({ type: CREATE_PASSWORD_CREATE_PASSWORD_SUCCESS, response });

    return true;
  } catch (error) {
    dispatch({ type: CREATE_PASSWORD_CREATE_PASSWORD_FAILURE, error });
    return false;
  }
};

const DEFAULT_STATE = { passwordFieldsLoading: true, invalidUser: false, user: {} };

const createPasswordReducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case CREATE_PASSWORD_VALIDATE_USER_SUCCESS: {
      if (!action.response) {
        return { ...state, passwordFieldsLoading: false, invalidUser: true };
      }

      return { ...state, passwordFieldsLoading: false, invalidUser: false, user: action.response };
    }

    case CREATE_PASSWORD_VALIDATE_USER_FAILURE:
      return { ...state, passwordFieldsLoading: false, invalidUser: true };

    case CREATE_PASSWORD_CREATE_PASSWORD_FAILURE:
      return { ...state, error: action.error };

    default:
      return DEFAULT_STATE;
  }
};

export const selectPasswordFieldsLoading = state => state.createPassword.passwordFieldsLoading;
export const selectInvalidUser = state => state.createPassword.invalidUser;
export const selectPasswordUser = state => state.createPassword.user;

export default createPasswordReducer;
